export default __webpack_public_path__ + "static/ak-cached/24h/media/CloseButton.12c0f7e3.svg";